/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface MediaLinks
 */
export interface MediaLinks {
    /**
     * 
     * @type {string}
     * @memberof MediaLinks
     */
    websiteUrl: string;
    /**
     * 
     * @type {string}
     * @memberof MediaLinks
     */
    shopUrl: string;
    /**
     * 
     * @type {string}
     * @memberof MediaLinks
     */
    twitterUrl: string;
    /**
     * 
     * @type {string}
     * @memberof MediaLinks
     */
    facebookUrl: string;
    /**
     * 
     * @type {string}
     * @memberof MediaLinks
     */
    youtubeUrl: string;
    /**
     * 
     * @type {string}
     * @memberof MediaLinks
     */
    instagramUrl: string;
    /**
     * 
     * @type {string}
     * @memberof MediaLinks
     */
    twitchUrl: string;
}

/**
 * Check if a given object implements the MediaLinks interface.
 */
export function instanceOfMediaLinks(value: object): value is MediaLinks {
    if (!('websiteUrl' in value) || value['websiteUrl'] === undefined) return false;
    if (!('shopUrl' in value) || value['shopUrl'] === undefined) return false;
    if (!('twitterUrl' in value) || value['twitterUrl'] === undefined) return false;
    if (!('facebookUrl' in value) || value['facebookUrl'] === undefined) return false;
    if (!('youtubeUrl' in value) || value['youtubeUrl'] === undefined) return false;
    if (!('instagramUrl' in value) || value['instagramUrl'] === undefined) return false;
    if (!('twitchUrl' in value) || value['twitchUrl'] === undefined) return false;
    return true;
}

export function MediaLinksFromJSON(json: any): MediaLinks {
    return MediaLinksFromJSONTyped(json, false);
}

export function MediaLinksFromJSONTyped(json: any, ignoreDiscriminator: boolean): MediaLinks {
    if (json == null) {
        return json;
    }
    return {
        
        'websiteUrl': json['websiteUrl'],
        'shopUrl': json['shopUrl'],
        'twitterUrl': json['twitterUrl'],
        'facebookUrl': json['facebookUrl'],
        'youtubeUrl': json['youtubeUrl'],
        'instagramUrl': json['instagramUrl'],
        'twitchUrl': json['twitchUrl'],
    };
}

export function MediaLinksToJSON(json: any): MediaLinks {
    return MediaLinksToJSONTyped(json, false);
}

export function MediaLinksToJSONTyped(value?: MediaLinks | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'websiteUrl': value['websiteUrl'],
        'shopUrl': value['shopUrl'],
        'twitterUrl': value['twitterUrl'],
        'facebookUrl': value['facebookUrl'],
        'youtubeUrl': value['youtubeUrl'],
        'instagramUrl': value['instagramUrl'],
        'twitchUrl': value['twitchUrl'],
    };
}

